<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="values"
        :hide-default-header="empty"
        :height="values.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        item-key="none"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap"
    >
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.active="{item}">
        <div align="center">{{ item.active ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-store-bundle-dialog ref="dialog"/>
  </div>
</template>

<script>

import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {StoreBundleConfig} from "@/modules/redactor/models/product/StoreBundleConfig";

import RStoreBundleDialog from "@/modules/redactor/views/product/r-store-bundle-dialog.vue";

export default {
  name: "r-store-bundle-table",
  components: {RStoreBundleDialog},
  data: () => ({
    headers: [
      {text: 'Active', value: 'active'},
      {text: 'Points', value: 'points'},
      {text: 'Bundle', value: 'bundle'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  props: {
    title: VueTypes.string,
    items: VueTypes.arrayOf(StoreBundleConfig),
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    },
    empty() {
      return this.values.length === 0;
    }
  },
  methods: {
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            this.values.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone(), this.config)
          .then((data) => {
            const index = this.items.indexOf(item);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.values.indexOf(item);
        this.values.splice(index, 1);
      });
    }
  }
}
</script>
